import { render, staticRenderFns } from "./FullscreenArrow.vue?vue&type=template&id=0f43c41e&scoped=true&"
import script from "./FullscreenArrow.vue?vue&type=script&lang=ts&"
export * from "./FullscreenArrow.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenArrow.vue?vue&type=style&index=0&id=0f43c41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43c41e",
  null
  
)

export default component.exports